module.exports = __webpack_public_path__ + "assets/img/index-partner1.81f954de.jpg";